module.exports = __webpack_public_path__ + "img/full2-min.e2d2d985.png";